// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-light: #eef2ff;
  --success-color: #10b981;
  --danger-color: #ef4444;
  --text-dark: #1f2937;
  --text-medium: #4b5563;
  --text-light: #9ca3af;
  --bg-light: #f9fafb;
  --card-bg: #ffffff;
  --border-radius: 12px;
  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  --transition: all 0.3s ease;
}

.task-detail-container {
  padding: 1rem;
  background-color: #f4f6f8;
  display: flex;
  width: 100%;
  align-items: flex-start;
}

.task-card {
  background-color: var(--card-bg);
  border-radius: var(--border-radius-primary);
  box-shadow: var(--box-shadow);
  width: 100%;
  padding: 2rem;
}

.task-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #eee;
}
.task-header .task-header-data {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.client-actions {
  display: flex;
  gap: 0.75rem;
}
.client-actions button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;
}
.client-actions button.btn-update {
  background-color: var(--primary-light-bg);
  color: var(--primary-color);
  border: 1px solid var(--primary-color);
}
.client-actions button.btn-update:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}
.client-actions button.btn-delete {
  background-color: var(--danger-light-bg);
  color: var(--danger-color);
  border: 1px solid var(--danger-color);
}
.client-actions button.btn-delete:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.avatar {
  width: 64px;
  height: 64px;
  background-color: var(--primary-light);
  color: var(--primary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  font-weight: bold;
  margin-right: 1.5rem;
}

.task-title h2 {
  margin: 0;
  color: var(--text-dark);
  font-size: 1.5rem;
  font-weight: 600;
}

.task-status {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 500;
  margin-top: 0.5rem;
}
.task-status.active {
  background-color: rgba(16, 185, 129, 0.1);
  color: var(--success-color);
}
.task-status.inactive {
  background-color: rgba(239, 68, 68, 0.1);
  color: var(--danger-color);
}

.task-details-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1.5rem;
}

.view-task-detail-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}
.view-task-detail-item .icon {
  color: var(--primary-color);
  font-size: 1.25rem;
  margin-top: 0.25rem;
  flex-shrink: 0;
}
.view-task-detail-item label {
  display: block;
  color: var(--text-light);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
}
.view-task-detail-item p {
  margin: 0;
  color: var(--text-dark);
  font-size: 0.95rem;
  font-weight: 500;
}
.view-task-detail-item a {
  color: var(--primary-color);
  font-weight: 500;
  font-size: 0.95rem;
  text-decoration: underline;
}
.view-task-detail-item a:hover {
  text-decoration: none;
}
.view-task-detail-item.status-logs-section {
  grid-column: 1/-1;
}
.view-task-detail-item.status-logs-section > div {
  width: 100%;
}

.status-logs {
  margin-top: 1rem;
  position: relative;
}
.status-logs::before {
  content: "";
  position: absolute;
  left: 1rem;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(to bottom, var(--primary-color), var(--primary-light));
  z-index: 1;
}

.status-log-item {
  position: relative;
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.5rem;
  padding-left: 0.5rem;
}
.status-log-item:last-child {
  margin-bottom: 0;
}

.status-log-icon {
  position: relative;
  z-index: 2;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: var(--card-bg);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-right: 1rem;
  flex-shrink: 0;
}
.status-log-icon .icon {
  font-size: 1rem;
}
.status-log-icon .icon.success {
  color: var(--success-color);
}
.status-log-icon .icon.danger {
  color: var(--danger-color);
}

.status-log-content {
  flex: 1 1;
  background-color: var(--bg-light);
  border-radius: 8px;
  padding: 1rem;
  border-left: 3px solid transparent;
  transition: var(--transition);
}
.status-log-content:hover {
  background-color: #f1f5f9;
  border-left-color: var(--primary-color);
}

.status-log-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.status-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.status-badge.completed {
  background-color: rgba(16, 185, 129, 0.15);
  color: var(--success-color);
  border: 1px solid rgba(16, 185, 129, 0.3);
}
.status-badge.incomplete {
  background-color: rgba(239, 68, 68, 0.15);
  color: var(--danger-color);
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.status-log-date {
  color: var(--text-medium);
  font-size: 0.8rem;
  font-weight: 500;
  white-space: nowrap;
}

.status-log-user {
  color: var(--text-medium);
  font-size: 0.85rem;
  font-style: italic;
  margin-top: 0.25rem;
}

.status-logs p {
  text-align: center;
  color: var(--text-light);
  font-style: italic;
  padding: 2rem;
  background-color: var(--bg-light);
  border-radius: 8px;
  border: 2px dashed #e5e7eb;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(67, 97, 238, 0.2);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.error-message {
  color: var(--danger-color);
  font-size: 1rem;
  padding: 2rem;
  text-align: center;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .task-detail-container {
    padding: 1rem;
  }
  .task-card {
    padding: 1.5rem;
  }
  .task-details-grid {
    grid-template-columns: 1fr;
  }
  .status-log-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  .status-log-date {
    white-space: normal;
  }
  .status-logs::before {
    left: 0.75rem;
  }
  .status-log-icon {
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 0.75rem;
  }
  .status-log-icon .icon {
    font-size: 0.875rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ViewTask/ViewTask.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,4CAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;AACF;;AAEA;EACE,gCAAA;EACA,2CAAA;EACA,6BAAA;EACA,WAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,6BAAA;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAEJ;;AACE;EACA,aAAA;EACA,YAAA;AAEF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AAEJ;AAAI;EACE,yCAAA;EACA,2BAAA;EACA,sCAAA;AAEN;AAAM;EACE,YAAA;EACA,2BAAA;AAER;AAEI;EACE,wCAAA;EACA,0BAAA;EACA,qCAAA;AAAN;AAEM;EACE,YAAA;EACA,2BAAA;AAAR;;AAMA;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;AAHF;;AAOE;EACE,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AAJJ;;AAQA;EACE,qBAAA;EACA,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AALF;AAOE;EACE,yCAAA;EACA,2BAAA;AALJ;AAQE;EACE,wCAAA;EACA,0BAAA;AANJ;;AAUA;EACE,aAAA;EACA,4DAAA;EACA,WAAA;AAPF;;AAUA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAPF;AASE;EACE,2BAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAPJ;AAUE;EACE,cAAA;EACA,wBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;AARJ;AAWE;EACE,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AATJ;AAYE;EACE,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;AAVJ;AAYI;EACE,qBAAA;AAVN;AAeE;EACE,iBAAA;AAbJ;AAeI;EACE,WAAA;AAbN;;AAmBA;EACE,gBAAA;EACA,kBAAA;AAhBF;AAkBE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,kFAAA;EACA,UAAA;AAhBJ;;AAoBA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;AAjBF;AAmBE;EACE,gBAAA;AAjBJ;;AAqBA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;EACA,kBAAA;EACA,cAAA;AAlBF;AAoBE;EACE,eAAA;AAlBJ;AAoBI;EACE,2BAAA;AAlBN;AAqBI;EACE,0BAAA;AAnBN;;AAwBA;EACE,SAAA;EACA,iCAAA;EACA,kBAAA;EACA,aAAA;EACA,kCAAA;EACA,6BAAA;AArBF;AAuBE;EACE,yBAAA;EACA,uCAAA;AArBJ;;AAyBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;AAtBF;;AAyBA;EACE,wBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAtBF;AAwBE;EACE,0CAAA;EACA,2BAAA;EACA,yCAAA;AAtBJ;AAyBE;EACE,yCAAA;EACA,0BAAA;EACA,wCAAA;AAvBJ;;AA2BA;EACE,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAxBF;;AA2BA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AAxBF;;AAiCA;EACE,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,iCAAA;EACA,kBAAA;EACA,0BAAA;AA9BF;;AAiCA;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,sCAAA;EACA,kBAAA;EACA,kCAAA;AA9BF;;AAiCA;EACE,0BAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AA9BF;;AAiCA;EACE;IACE,yBAAA;EA9BF;AACF;AAiCA;EACE;IACE,aAAA;EA/BF;EAkCA;IACE,eAAA;EAhCF;EAmCA;IACE,0BAAA;EAjCF;EAoCA;IACE,sBAAA;IACA,uBAAA;IACA,WAAA;EAlCF;EAqCA;IACE,mBAAA;EAnCF;EAuCE;IACE,aAAA;EArCJ;EAyCA;IACE,aAAA;IACA,cAAA;IACA,qBAAA;EAvCF;EAyCE;IACE,mBAAA;EAvCJ;AACF","sourcesContent":[":root {\n  --primary-light: #eef2ff;\n  --success-color: #10b981;\n  --danger-color: #ef4444;\n  --text-dark: #1f2937;\n  --text-medium: #4b5563;\n  --text-light: #9ca3af;\n  --bg-light: #f9fafb;\n  --card-bg: #ffffff;\n  --border-radius: 12px;\n  --box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  --transition: all 0.3s ease;\n}\n\n.task-detail-container {\n  padding: 1rem;\n  background-color: #f4f6f8;\n  display: flex;\n  width: 100%;\n  align-items: flex-start;\n}\n\n.task-card {\n  background-color: var(--card-bg);\n  border-radius: var(--border-radius-primary);\n  box-shadow: var(--box-shadow);\n  width: 100%;\n  padding: 2rem;\n}\n\n.task-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 2rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 1px solid #eee;\n  .task-header-data {\n    display: flex;\n    align-items: center;\n    gap: 1.5rem;\n  }\n}\n  .client-actions {\n  display: flex;\n  gap: 0.75rem;\n  \n  button {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.5rem 1rem;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n    font-size: 0.875rem;\n    font-weight: 500;\n    transition: all 0.2s;\n    \n    &.btn-update {\n      background-color: var(--primary-light-bg);\n      color: var(--primary-color);\n      border: 1px solid var(--primary-color);\n      \n      &:hover {\n        opacity: 0.9;\n        transform: translateY(-1px);\n      }\n    }\n    \n    &.btn-delete {\n      background-color: var(--danger-light-bg);\n      color: var(--danger-color);\n      border: 1px solid var(--danger-color);\n      \n      &:hover {\n        opacity: 0.9;\n        transform: translateY(-1px);\n      }\n    }\n  }\n}\n\n.avatar {\n  width: 64px;\n  height: 64px;\n  background-color: var(--primary-light);\n  color: var(--primary-color);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.75rem;\n  font-weight: bold;\n  margin-right: 1.5rem;\n}\n\n.task-title {\n  h2 {\n    margin: 0;\n    color: var(--text-dark);\n    font-size: 1.5rem;\n    font-weight: 600;\n  }\n}\n\n.task-status {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  margin-top: 0.5rem;\n\n  &.active {\n    background-color: rgba(16, 185, 129, 0.1);\n    color: var(--success-color);\n  }\n\n  &.inactive {\n    background-color: rgba(239, 68, 68, 0.1);\n    color: var(--danger-color);\n  }\n}\n\n.task-details-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 1.5rem;\n}\n\n.view-task-detail-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n\n  .icon {\n    color: var(--primary-color);\n    font-size: 1.25rem;\n    margin-top: 0.25rem;\n    flex-shrink: 0;\n  }\n\n  label {\n    display: block;\n    color: var(--text-light);\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: 0.25rem;\n  }\n\n  p {\n    margin: 0;\n    color: var(--text-dark);\n    font-size: 0.95rem;\n    font-weight: 500;\n  }\n\n  a {\n    color: var(--primary-color);\n    font-weight: 500;\n    font-size: 0.95rem;\n    text-decoration: underline;\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n\n  // Special styling for status logs section\n  &.status-logs-section {\n    grid-column: 1 / -1; // Span full width\n    \n    > div {\n      width: 100%;\n    }\n  }\n}\n\n// Status Logs Styling\n.status-logs {\n  margin-top: 1rem;\n  position: relative;\n  \n  &::before {\n    content: '';\n    position: absolute;\n    left: 1rem;\n    top: 0;\n    bottom: 0;\n    width: 2px;\n    background: linear-gradient(to bottom, var(--primary-color), var(--primary-light));\n    z-index: 1;\n  }\n}\n\n.status-log-item {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 1.5rem;\n  padding-left: 0.5rem;\n  \n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.status-log-icon {\n  position: relative;\n  z-index: 2;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 50%;\n  background-color: var(--card-bg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  margin-right: 1rem;\n  flex-shrink: 0;\n\n  .icon {\n    font-size: 1rem;\n    \n    &.success {\n      color: var(--success-color);\n    }\n    \n    &.danger {\n      color: var(--danger-color);\n    }\n  }\n}\n\n.status-log-content {\n  flex: 1;\n  background-color: var(--bg-light);\n  border-radius: 8px;\n  padding: 1rem;\n  border-left: 3px solid transparent;\n  transition: var(--transition);\n  \n  &:hover {\n    background-color: #f1f5f9;\n    border-left-color: var(--primary-color);\n  }\n}\n\n.status-log-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.status-badge {\n  padding: 0.25rem 0.75rem;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  \n  &.completed {\n    background-color: rgba(16, 185, 129, 0.15);\n    color: var(--success-color);\n    border: 1px solid rgba(16, 185, 129, 0.3);\n  }\n  \n  &.incomplete {\n    background-color: rgba(239, 68, 68, 0.15);\n    color: var(--danger-color);\n    border: 1px solid rgba(239, 68, 68, 0.3);\n  }\n}\n\n.status-log-date {\n  color: var(--text-medium);\n  font-size: 0.8rem;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.status-log-user {\n  color: var(--text-medium);\n  font-size: 0.85rem;\n  font-style: italic;\n  margin-top: 0.25rem;\n  \n  // &::before {\n  //   content: '👤 ';\n  //   margin-right: 0.25rem;\n  // }\n}\n\n// Empty state for status logs\n.status-logs p {\n  text-align: center;\n  color: var(--text-light);\n  font-style: italic;\n  padding: 2rem;\n  background-color: var(--bg-light);\n  border-radius: 8px;\n  border: 2px dashed #e5e7eb;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(67, 97, 238, 0.2);\n  border-top-color: var(--primary-color);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.error-message {\n  color: var(--danger-color);\n  font-size: 1rem;\n  padding: 2rem;\n  text-align: center;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 768px) {\n  .task-detail-container {\n    padding: 1rem;\n  }\n\n  .task-card {\n    padding: 1.5rem;\n  }\n\n  .task-details-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .status-log-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n  \n  .status-log-date {\n    white-space: normal;\n  }\n  \n  .status-logs {\n    &::before {\n      left: 0.75rem;\n    }\n  }\n  \n  .status-log-icon {\n    width: 1.5rem;\n    height: 1.5rem;\n    margin-right: 0.75rem;\n    \n    .icon {\n      font-size: 0.875rem;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
